import React from 'react'

import i18n from 'i18n'

import backgroundImage from './i/background.svg'

import styles from './Placeholder.module.scss'

const Placeholder = ({ title = i18n.t('Data will appear here'), description = i18n.t('No records yet') }) => (
    <div className={styles.placeholder}>
        <div className={styles.text}>
            {!!title && <div className={styles.title}>{title}</div>}
            {!!description && <div className={styles.description}>{description}</div>}
        </div>
        <img src={backgroundImage} alt="background" />
    </div>
)

export default Placeholder
